import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "./siteData";
import { Reveal } from "./Reveal";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="bg-zinc-950 py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-gold font-semibold uppercase tracking-[0.25em] text-sm">
            Member Stories
          </span>
          <h2 className="font-bebas text-5xl sm:text-6xl text-white mt-3 leading-none">
            Real People, Real Results
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 90}>
              <div className="bg-zinc-900 border border-white/10 rounded-2xl p-8 h-full flex flex-col">
                <Quote size={32} className="text-gold/40" />
                <p className="text-zinc-200 font-body mt-4 flex-1">"{t.quote}"</p>
                <div className="flex items-center gap-1 text-gold mt-6">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={15} fill="currentColor" />
                  ))}
                </div>
                <div className="mt-4">
                  <p className="font-bebas text-xl text-white tracking-wide">{t.name}</p>
                  <p className="text-zinc-500 text-sm font-body">{t.since}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
